import React, { useState } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { useCurrencies, useQueryParams } from "../../utils/hooks";
import { useQuery } from "react-query";
import { useAuth } from "../../hooks/useAuth";

import queryString from "query-string";
import ReactPaginate from "react-paginate";
import { paginationOptions } from "../../utils/helpers";
import { LoaderIcon, Logo } from "../Icons";
import currency from "currency.js";
import { toast } from "react-toastify";
import { useStoreState } from "easy-peasy";
import { useNavigate } from "react-router-dom";

import restaurantImage from "../../assets/images/restaurant.png";
import { FaPlus } from "react-icons/fa";

const MenuCard = ({ item }) => {
  const { customerBackendUrl: backendUrl } = useAuth();
  const { prevailingCurrencySymbol } = useCurrencies();

  const getImageUrl = () => {
    const image = item?.images ? JSON.parse(item?.images) : [];
    let imageUrl = image[0]?.systemFileName;
    imageUrl = imageUrl
      ? `${backendUrl}/api/items/view-file/${imageUrl}`
      : "https://shop.pointsbud.com/_nuxt/img/spirit-shot.51954ca.png";

    return imageUrl;
  };

  return (
    <>
      <div className="col-12">
        <div
          className="card border-0 shadow-sm h-100 position-relative"
          style={{ transition: "all 0.3s ease" }}
        >
          <div className="card-body p-4">
            <div className="row align-items-start">
              {/* Left Content */}
              <div className="col-8">
                <div className="mb-3">
                  <h5 className="card-title fw-bold text-dark mb-2">
                    {item?.title || ""}
                  </h5>
                  <p className="card-text text-muted  lh-base mb-0">
                    {item?.description || ""}
                    <span
                      className="text-warning ms-1"
                      style={{
                        cursor: "pointer",
                        textDecoration: "none",
                      }}
                    >
                      see more
                    </span>
                  </p>
                </div>
                <div className="fs-5 fw-bold text-dark">
                  {currency(item?.price).format({
                    symbol: prevailingCurrencySymbol,
                    separator: ",",
                  })}
                </div>
              </div>

              {/* Right Content - Image and Add Button */}
              <div className="col-4">
                <div className="position-relative">
                  <div
                    className="rounded-3 overflow-hidden  w-100"
                    style={{ height: "250px" }}
                  >
                    <img
                      src={getImageUrl()}
                      alt={"img"}
                      className="img-fluid w-100 h-100"
                      style={{ objectFit: "contain" }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        .card:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1) !important;
        }

        .text-warning:hover {
          color: #f8960d !important;
        }

        .btn-dark:hover {
          background-color: #495057 !important;
        }

        .btn-warning:hover {
          background-color: #f8960d !important;
          border-color: #f8960d !important;
        }
      `}</style>
    </>
  );
};

const CustomMenuPage = () => {
  const navigate = useNavigate();
  const initialFilterParams = {
    page: 1,
    limit: 150, // Increased to get more items
    isGrouped: true,
  };
  const [queryParams] = useQueryParams({
    page: 1,
    limit: 150,
    ...initialFilterParams,
  });

  const { customerBackendUrl: backendUrl } = useAuth();

  const { data, isFetching } = useQuery(
    [queryParams],
    () => getItems(queryParams),
    {
      onSuccess: ({ categories }) => {
        setTitle(categories[0]?.title || "");
      },
      keepPreviousData: true,
    }
  );

  const [textTitle, setTitle] = useState("");

  const fetchSetUpData = async () => {
    // await waitFor(5000);
    let response = await fetch(`${backendUrl}/api/store/set-up`, {
      method: "GET",
      headers: {
        Accept: "Application/json",
        "Content-Type": "Application/json",
      },
      credentials: "include",
    });

    if (!response.ok) {
      response = await response.json();
      throw new Error(response.message);
    }

    const { data } = await response.json();

    return data;
  };

  const { data: settings, isLoading } = useQuery(
    ["STORE_NAV_SET_UP"],
    () => fetchSetUpData(),
    {
      keepPreviousData: true,
    }
  );
  if (!isLoading && !settings?.settings?.enableCustomStoreMenu) {
    return (
      <div
        className="vw-100 d-flex align-items-center justify-content-center text-center "
        style={{ height: "60vh" }}
      >
        <div>
          <Logo />
          <h4 className="display-5"> Unauthorized</h4>{" "}
          <Button
            onClick={() => navigate(-1)}
            variant=""
            className="text-primary text-underline"
          >
            Go back
          </Button>
        </div>
      </div>
    );
  }

  const getItems = async (debouncedqueryParams) => {
    let response = await fetch(
      `${backendUrl}/api/store/custom-store-menu-list?${queryString.stringify(
        debouncedqueryParams
      )}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        credentials: "include",
      }
    );

    if (!response.ok) {
      response = await response.json();
      throw new Error(response.message);
    }

    const data = await response.json();

    return data;
  };

  const handleShare = () => {
    if (navigator.share) {
      navigator.share({
        title: data?.company?.CompName,
        text: `Check out our menu at ${data?.company?.CompName}!`,
        url: window.location.href,
      });
    } else {
      // Fallback for browsers that don't support Web Share API
      navigator.clipboard.writeText(window.location.href).then(() => {
        toast.success("Link copied to clipboard!");
      });
    }
  };

  // Loading state
  if (isFetching && !data) {
    return (
      <div className="global-spinner">
        <LoaderIcon className="spin text-primary" />
      </div>
    );
  }

  return (
    <>
      <div className="container-fluid bg-white py-2">
        <div className="row justify-content-center sticky-top bg-white py-4">
          <div className="col-lg-8 ">
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <div className="">
                  <img
                    src={`${backendUrl}/api/users/logo/company`}
                    alt=""
                    width={100}
                    height={100}
                  />{" "}
                </div>
                <div
                  className="d-flex flex-column justify-content-between "
                  style={{ height: "100%", justifyContent: "space-between" }}
                >
                  <div className="px-4 ">
                    <h4
                      className=" fw-bold mb-0 text-black"
                      style={{ fontSize: "24px", lineHeight: "1.1" }}
                    >
                      {" "}
                      {settings?.company?.CompName}
                    </h4>
                  </div>

                  <div className="p-4 pb-4   text-black">
                    <div
                      className=""
                      style={{ fontSize: "14px", lineHeight: "1.4" }}
                    >
                      <div className="mb-1">
                        {" "}
                        {settings?.company?.AddressLine1}
                      </div>
                      <div className="mb-1">
                        {settings?.company?.AddressLine2}
                      </div>
                      <div>{settings?.company?.Phone}</div>
                    </div>
                  </div>
                </div>
              </div>
              <h3>Menu</h3>
            </div>
            {data?.categories?.map(({ title }) => (
              <a href={`#${title}`} className=" ">
                <button
                  onClick={() => setTitle(title)}
                  className="p-2 px-4 fw-bold mx-3 mb-3"
                  style={{
                    border: "1px solid black",
                    borderRadius: "40px",
                    backgroundColor:
                      title === textTitle ? "black" : "transparent",
                    color: title === textTitle ? "white" : "black",
                  }}
                >
                  {title}
                </button>
              </a>
            ))}
          </div>
        </div>
        {Object.entries(data?.data).map(([category, items]) => (
          <div
            className="row justify-content-center"
            id={category}
            key={category}
          >
            <div className="col-lg-8 ">
              {/* Header */}
              <div className="text-center mt-5 mb-3">
                <h4 className="fw-bold text-dark mb-3">{category}</h4>
                <div
                  className="mx-auto"
                  style={{
                    width: "60px",
                    height: "2px",
                    backgroundColor: "#fd7e14",
                  }}
                />
              </div>

              {/* Menu Items */}

              {items.map((item, index) => (
                <div className="row g-4 mb-3" key={index}>
                  <MenuCard item={item} />
                </div>
              ))}
            </div>
          </div>
        ))}

        <div className="text-center mt-5">
          <button className="btn btn-warning btn-lg px-5 py-3 fw-semibold">
            View Cart
          </button>
        </div>
      </div>
    </>
  );
};

export default CustomMenuPage;
